import "./navbar.scss";
import Modal from "react-bootstrap/Modal";
import { useState, useEffect, useContext, useRef } from "react";
import { useWeb3React } from "@web3-react/core";
import useAuth from "../../../hooks/useAuth";
import Offcanvas from "react-bootstrap/Offcanvas";
import useRecordEvent from "../../../hooks/useRecordEvent";
import { useEventSessionContext } from "../../../contexts/EventSessionContext";
import Environment from "../../../utils/Environment";
import useWeb3ErrorToast from "../../../utils/useWeb3ErrorToast";
import {
  clearWalletSession,
  isWalletSessionExpired,
  setWalletSession,
} from "../../../utils/walletSession";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { notifyInfo } from "../../Toast";

const Navbar = ({ show, setShow }) => {
  const Presale = Environment.presale;
  const role = localStorage?.getItem("role_ins");
  const { login, logout } = useAuth();
  const { account, chainId } = useWeb3React();
  const { recordEvent } = useRecordEvent();
  const { handleError } = useWeb3ErrorToast();
  const { eventSessionId } = useEventSessionContext();

  const accountChangedRef = useRef(false);

  useEffect(() => {
    const path = window.location.pathname;
    const sessionId = eventSessionId || localStorage.getItem("eventSessionId");

    // allow root
    if (path === "/") return;

    // block all other routes if no session
    if (!sessionId) {
      window.location.replace("/");
    }
  }, []);

  useEffect(() => {
    if (!account) return;

    const stored = localStorage.getItem("walletEvent");
    const walletEvent = stored ? JSON.parse(stored) : null;

    const shouldFire =
      !walletEvent || walletEvent.account !== account.toLowerCase();

    if (shouldFire) {
      accountChangedRef.current = true;
      if (stored) {
        notifyInfo(
          "Account changed. Your session has been updated to your current wallet address.",
          "account-swap",
        );

        // toast.info(
        //   "Account changed. Your session has been updated to your current wallet address.",
        //   { toastId: "account-swap" }
        // );
      }
      setWalletSession();
      callRecordEvent("connected");
    }
  }, [account]);

  useEffect(() => {
    if (!account) return;

    if (accountChangedRef.current) {
      accountChangedRef.current = false;
      return;
    }

    const checkSession = async () => {
      if (isWalletSessionExpired()) {
        const connectorId = localStorage.getItem("connectorId");

        await logout(connectorId);
        clearWalletSession();

        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");
        localStorage.removeItem("hasReloadedAfterConnect");

        notifyInfo(
          "Your session has timed out. Please reconnect wallet to continue your purchase.",
          "wallet-session-expired",
        );
        // toast.warning(
        //   "Your session has timed out. Please reconnect wallet to continue your purchase.",
        //   { toastId: "wallet-session-expired" }
        // );
      }
    };

    checkSession();
  }, [account]);

  // useEffect(() => {
  //   if (!chainId || !account) return;

  //   const hasReloaded = localStorage.getItem("hasReloadedAfterConnect");

  //   if (!hasReloaded) {
  //     localStorage.setItem("hasReloadedAfterConnect", "true");
  //     window.location.reload();
  //   }
  // }, [account, chainId]);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    if (setShow) {
      setShow(true);
    }
  };

  const trustWallet = async () => {
    if (account) {
      try {
        await callRecordEvent("disconnected");
        await logout("walletconnect");
        clearWalletSession();
        localStorage.clear();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("walletconnect");
        handleClose();
        setWalletSession();
        localStorage.setItem("connectorId", "walletconnect");
        localStorage.setItem("flag", "true");
      } catch (err) {
        console.log("eerr", err);
        handleError(err);
      }
    }
  };

  const callRecordEvent = async (status) => {
    const accessCode = localStorage.getItem("accessCode");
    if (!accessCode || !account) return;

    const metaData = {
      connectWallet: [
        {
          walletAddress: account.toLowerCase(),
          status,
          connectedAt: Date.now(),
        },
      ],
    };

    await recordEvent(metaData);

    // persist AFTER successful fire
    localStorage.setItem(
      "walletEvent",
      JSON.stringify({
        logged: true,
        presale: Presale.apiTag,
        account: account.toLowerCase(),
      }),
    );
  };

  const connectMetaMask1 = async () => {
    if (account) {
      try {
        const connectorId = window.localStorage.getItem("connectorId");
        await callRecordEvent("disconnected");
        await logout(connectorId);
        clearWalletSession();
        localStorage.removeItem("connectorId");
        localStorage.removeItem("flag");
        localStorage.removeItem("verifiedData");
        localStorage.removeItem("hasReloadedAfterConnect");
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    } else {
      try {
        login("injected");
        setWalletSession();
        localStorage.setItem("connectorId", "injected");
        localStorage.setItem("flag", "true");
        handleClose();
      } catch (err) {
        console.log("err", err);
        handleError(err);
      }
    }
  };

  const handleGemsClick = ()=> {
    const gemsLanding = "https://gems.vip/";
    window.open(gemsLanding, "_blank")
  }

  const [showw, setShoww] = useState(false);
  const handleClosew = () => setShoww(false);
  const handleShoww = () => setShoww(true);
  const TomiPayBol = localStorage.getItem("IsTomipay");
  const providerNull = localStorage.getItem("provider");
  // console.log("payyy", TomiPayBol)

  // for tomi variable

  //   useEffect(() => {
  //     // tomiPayWallet()
  //     // alert(TomiPayBol)

  // if(!account)

  //     {  // console.log("in hool",a)
  //       if (TomiPayBol == 'true') {
  //         // alert(`providerNull=${providerNull}`)
  //         trustWallet();
  //         // alert(`TomiPayBol=${TomiPayBol}`)
  //         if (providerNull=='true') {
  //           setShow(true)
  //         }
  //       }}

  //   }, [TomiPayBol,providerNull])

  return (
    <>
      <section className="main-navbar">
        <div className="custom-container">
          <nav class="navbar navbar-expand-lg p-0">
            <a class="navbar-brand">
              <img src="\logo.svg" alt="img" className="img-fluid" onClick={handleGemsClick} style={{cursor:"pointer"}}/>
            </a>
            <button class="navbar-toggler" type="button" onClick={handleShoww}>
              <img
                src="\assets\navbar-bar.svg"
                alt="img"
                className="img-fluid"
              />
            </button>
            <div
              class="collapse navbar-collapse justify-content-end"
              id="navbarSupportedContent"
            >
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item">
                  <a href="/buy" class="nav-link active" aria-current="page">
                    Buy
                  </a>
                </li>
                <li class="nav-item">
                  <a href="/claim" class="nav-link">
                    My Purchases
                  </a>
                </li>
                {/* <li class="nav-item">
                  <div class="dropdown">
                    <button
                      class="dropdown-toggle"
                      type="button"
                      id="dropdownMenuButton1"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      Help Center
                    </button>
                    <ul
                      class="dropdown-menu"
                      aria-labelledby="dropdownMenuButton1"
                    >
                      <li>
                        <Link to="/faqs" class="dropdown-item">
                          FAQs
                        </Link>
                      </li>
                      <li>
                        <Link to="/education-videos" class="dropdown-item">
                          Education Videos
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li> */}

                {/* {role != "institution" && (
                  <li class="nav-item">
                    <a href="/discount" class="nav-link">
                      Gems Premium
                    </a>
                  </li>
                )} */}
                {/* <li class="nav-item">
                  <a href="/ClaimNft" class="nav-link">
                    NFT
                  </a>
                </li> */}
              </ul>
              {/* <a href="https://dop.org/" className="connect-btn me-2">
                go to dop.org
              </a> */}
              {!account ? (
                <button className="connect-btn" onClick={handleShow}>
                  Connect Wallet
                </button>
              ) : (
                <div className="dissconnect-btn">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    onClick={connectMetaMask1}
                    cursor="pointer"
                  >
                    <path
                      d="M6.6665 14.1663L2.49984 9.99967L6.6665 5.83301"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M2.5 10H12.5"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M12.5 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0118C17.3244 16.6993 17.5 16.2754 17.5 15.8333V4.16667C17.5 3.72464 17.3244 3.30072 17.0118 2.98816C16.6993 2.67559 16.2754 2.5 15.8333 2.5H12.5"
                      stroke="#FC4F52"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {account.slice(0, 6)}...{account.slice(-4, account.length)}
                  {/* 0x29d7...e86b */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    cursor="pointer"
                    onClick={() => {
                      navigator.clipboard?.writeText(account) ||
                        (() => {
                          const t = document.createElement("textarea");
                          t.value = account;
                          document.body.appendChild(t);
                          t.select();
                          document.execCommand("copy");
                          document.body.removeChild(t);
                        })();
                    }}
                  >
                    <g clip-path="url(#clip0_935_5965)">
                      <path
                        d="M11.6665 4.6665H5.83317C5.18884 4.6665 4.6665 5.18884 4.6665 5.83317V11.6665C4.6665 12.3108 5.18884 12.8332 5.83317 12.8332H11.6665C12.3108 12.8332 12.8332 12.3108 12.8332 11.6665V5.83317C12.8332 5.18884 12.3108 4.6665 11.6665 4.6665Z"
                        stroke="#77868B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.33317 9.33317C1.6915 9.33317 1.1665 8.80817 1.1665 8.16651V2.33317C1.1665 1.6915 1.6915 1.1665 2.33317 1.1665H8.16651C8.80817 1.1665 9.33317 1.6915 9.33317 2.33317"
                        stroke="#77868B"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_935_5965">
                        <rect width="14" height="14" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              )}
            </div>
          </nav>
        </div>
      </section>

      <Modal
        className="connectwallet-modal"
        show={show}
        onHide={handleClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="twice-btns">
            <button className="forhideee" onClick={connectMetaMask1}>
              <img src="\assets\metamask.svg" alt="img" className="img-fluid" />
              <h6>Metamask</h6>
            </button>
            {/* {TomiPayBol == 'true' ?
              <button onClick={trustWallet}>
                <img
                  src="\assets\tomiPAYLogo.png"
                  alt="img"
                  className="img-fluid payyy"
                />
                <h6>tomiPAY</h6>
              </button>
              : */}
            <button onClick={trustWallet}>
              <img
                src="\assets\walletconnect.svg"
                alt="img"
                className="img-fluid"
              />
              <h6>WalletConnect</h6>
            </button>

            {/* } */}
          </div>
        </Modal.Body>
      </Modal>

      <Offcanvas className="mobile-navbar" show={showw} onHide={handleClosew}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {" "}
            <img src="\logo.svg" alt="img" className="img-fluid" />{" "}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <a href="/buy">Buy</a>
          <a href="/claim">My Purchases</a>
          {/* <Link to="/faqs">Faqs</Link>
          <Link to="/education-videos">Education Videos</Link> */}

          {/* {role != "institution" && (
            <a href="/discount" class="nav-link">
              Gems Premium
            </a>
          )} */}
          {/* <a href="/ClaimNft">NFT</a> */}
          <div className="btnss">
            {/* {TomiPayBol ?
              '' : */}
            <>
              {!account ? (
                <button
                  className="connect-btn"
                  onClick={() => {
                    handleClosew();
                    handleShow();
                  }}
                >
                  Connect Wallet
                </button>
              ) : (
                <button className="dissconnect-btn" onClick={connectMetaMask1}>
                  Disconnect
                </button>
              )}
            </>
            {/* } */}
            {/* <a href="https://dop.org/" className="connect-btn mt-2 w-100">
              go to dop.org
            </a> */}
          </div>
        </Offcanvas.Body>
        {/* <img
          src="\assets\mblviewbg.png"
          alt="img"
          className="img-fluid mblviewbanner-bg"
        /> */}
      </Offcanvas>
    </>
  );
};

export default Navbar;
